import './reducers';
import { createReduxStore } from './store';
import createConnect from 'redux-connect-standalone';

export const store = createReduxStore();
export const reduxConnect = createConnect(store);
